import Vue from 'vue'

const exportParams = {
  headers: { Accept: 'application/vnd.ms-excel' },
  responseType: 'arraybuffer'
}

export const emailTemplates = () => Vue.axios.get('emailTemplates')
export const updateEmailTemplate = (id, data) => Vue.axios.put(`emailTemplates/${id}`, data)

export const getNewsletters = params => Vue.axios.get('newsletters', { params })
export const createNewsletter = data => Vue.axios.post('newsletters', data)
export const getNewsletter = id => Vue.axios.get(`newsletters/${id}`)
export const updateNewsletter = (id, data) => Vue.axios.put(`newsletters/${id}`, data)
export const uploadRecipients = (id, recipients) => Vue.axios.put(`newsletters/${id}/recipients`, recipients)
export const previewNewsletter = (id, toEmail) => Vue.axios.post(`newsletters/${id}/preview`, { toEmail })
export const dispatchNewsletter = id => Vue.axios.post(`newsletters/${id}/dispatch`)
export const abortNewsletter = id => Vue.axios.put(`newsletters/${id}/aborted`)
export const deleteNewsletter = id => Vue.axios.delete(`newsletters/${id}`)

export const getHolidays = params => Vue.axios.get('calendar/holidays', { params })
export const createHoliday = data => Vue.axios.put('calendar/holidays', data)
export const deleteHoliday = dates => Vue.axios({
  method: 'delete',
  url: `calendar/holidays`,
  data: { dates }
})

export const exportAdvertActivations = params => Vue.axios.get('exports/adverts/activations', { ...exportParams, params })
export const exportAdWatchActivations = params => Vue.axios.get('exports/adwatches/activations', { ...exportParams, params })

export const exportPrivateUsers = params => Vue.axios.get('exports/users/private', { ...exportParams, params })
export const exportPrivateBidSessions = params => Vue.axios.get('exports/bidSessions/private', {
  ...exportParams,
  params
})
export const exportPrivateBids = params => Vue.axios.get('exports/bids/private', { ...exportParams, params })
export const exportPrivateOffers = params => Vue.axios.get('exports/offers/private', { ...exportParams, params })
export const exportAdvertsWithLocation = params => Vue.axios.get('exports/adverts/withlocation', { ...exportParams, params })

export const exportCorporateUsers = params => Vue.axios.get('exports/users/corporate', { ...exportParams, params })
export const exportCorporateBidSessions = params => Vue.axios.get('exports/bidSessions/corporate', {
  ...exportParams,
  params
})
export const exportCorporateBids = params => Vue.axios.get('exports/bids/corporate', { ...exportParams, params })
export const exportCorporateOffers = params => Vue.axios.get('exports/offers/corporate', { ...exportParams, params })
export const exportAdWatchesWithLocation = params => Vue.axios.get('exports/adwatches/withlocation', { ...exportParams, params })
export const exportNewsletterUnsubscribers = params => Vue.axios.get('exports/newsletters/unsubscribers', {
  ...exportParams,
  params
})

export const exportCompetencyTestResults = params => Vue.axios.get('exports/surveys/comptest', { ...exportParams, params })



// WEBPACK FOOTER //
// ./src/services/admin.js